export default __webpack_public_path__ + "static/media/bulb-1-30-min.6e58608f.png";